"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useEventListener(eventName, handler, element = window) {
    // Create a ref that stores handler
    const savedHandler = (0, react_1.useRef)(null);
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    (0, react_1.useEffect)(() => {
        savedHandler.current = handler;
    }, [handler]);
    (0, react_1.useEffect)(() => {
        // Create event listener that calls handler function stored in ref
        const eventListener = event => {
            if (savedHandler.current) {
                savedHandler.current(event);
            }
        };
        // Add event listener
        element.addEventListener(eventName, eventListener);
        // Remove event listener on cleanup
        return () => {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element]);
}
exports.default = useEventListener;
